﻿// Global 401 handler — fires when probench session cookie has expired (after 24h)
(function () {
    $.ajaxSetup({
        statusCode: {
            401: function () {
                // Public pages load this file via /managerjs/ and expect 401s for signed-out visitors.
                if (window.location.pathname.toLowerCase().indexOf('/manager/') !== 0) return;
                if (document.getElementById('pb-session-banner')) return;

                var SECONDS = 5;
                var remaining = SECONDS;
                var circumference = 2 * Math.PI * 22;

                var bgColor      = '#24221e';
                var accentColor  = '#f04438';
                var accentTile   = 'rgba(240,68,56,0.12)';
                var ringColor    = '#f79009';
                var fontFamily   = "'Inter',ui-sans-serif,system-ui,-apple-system,'Segoe UI',sans-serif";
                var bannerShadow = '0 24px 48px -12px rgba(15,23,42,0.18)';
                var bannerEasing = 'cubic-bezier(.4,0,.2,1)';
                var btnBg        = 'transparent';
                var btnColor     = '#fff';
                var btnBorder    = '1.5px solid rgba(255,255,255,0.45)';

                var $banner = $(
                    '<div id="pb-session-banner" style="' +
                        'position:fixed;top:0;left:0;right:0;z-index:99999;' +
                        'background:' + bgColor + ';border-left:4px solid ' + accentColor + ';' +
                        'display:flex;align-items:center;gap:16px;padding:14px 24px;' +
                        'box-shadow:' + bannerShadow + ';' +
                        'transform:translateY(-100%);transition:transform 0.35s ' + bannerEasing + ';' +
                        'font-family:' + fontFamily + ';">' +

                      '<div style="flex-shrink:0;width:36px;height:36px;background:' + accentTile + ';' +
                           'border-radius:8px;display:flex;align-items:center;justify-content:center;">' +
                        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" ' +
                             'stroke="' + accentColor + '" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
                          '<rect x="3" y="11" width="18" height="11" rx="2"/>' +
                          '<path d="M7 11V7a5 5 0 0 1 10 0v4"/>' +
                        '</svg>' +
                      '</div>' +

                      '<div style="flex:1;min-width:0;">' +
                        '<div style="font-size:14px;font-weight:600;color:#fff;line-height:1.3;">' +
                          'Your session has expired' +
                        '</div>' +
                        '<div style="font-size:12.5px;color:rgba(255,255,255,0.72);margin-top:2px;">' +
                          'You were inactive for too long. Signing you out automatically.' +
                        '</div>' +
                      '</div>' +

                      '<div style="position:relative;width:52px;height:52px;flex-shrink:0;">' +
                        '<svg width="52" height="52" viewBox="0 0 52 52" ' +
                             'style="position:absolute;top:0;left:0;transform:rotate(-90deg);">' +
                          '<circle cx="26" cy="26" r="22" fill="none" ' +
                                  'stroke="rgba(255,255,255,0.2)" stroke-width="3"/>' +
                          '<circle id="pb-ring" cx="26" cy="26" r="22" fill="none" ' +
                                  'stroke="' + ringColor + '" stroke-width="3" stroke-linecap="round" ' +
                                  'stroke-dasharray="' + circumference + '" stroke-dashoffset="0" ' +
                                  'style="transition:stroke-dashoffset 0.9s linear;"/>' +
                        '</svg>' +
                        '<div id="pb-count" style="position:absolute;inset:0;display:flex;' +
                             'align-items:center;justify-content:center;' +
                             'font-size:18px;font-weight:600;color:' + ringColor + ';letter-spacing:-0.5px;">' +
                          SECONDS +
                        '</div>' +
                      '</div>' +

                      '<button id="pb-signin-now" style="font-family:' + fontFamily + ';' +
                           'font-size:13px;font-weight:600;color:' + btnColor + ';background:' + btnBg + ';' +
                           'border:' + btnBorder + ';border-radius:6px;' +
                           'padding:8px 16px;cursor:pointer;white-space:nowrap;flex-shrink:0;">' +
                        'Sign in now' +
                      '</button>' +

                    '</div>'
                );

                $('body').prepend($banner);

                requestAnimationFrame(function () {
                    requestAnimationFrame(function () {
                        $('#pb-session-banner').css('transform', 'translateY(0)');
                    });
                });

                $('#pb-signin-now').on('click', function () {
                    window.location.href = window.location.origin + '/Manager/SignOut.aspx';
                });

                function tick() {
                    remaining--;
                    var offset = circumference * (1 - remaining / SECONDS);
                    $('#pb-ring').css('stroke-dashoffset', offset);
                    $('#pb-count').text(remaining);
                    if (remaining <= 0) {
                        window.location.href = window.location.origin + '/Manager/SignOut.aspx';
                    } else {
                        setTimeout(tick, 1000);
                    }
                }
                setTimeout(tick, 1000);
            }
        }
    });
}());

$(document).ready(function () {
    localStorage.setItem('SignIn_Click', '');
    getUrlforAPI();
    $('#ctl00_Body_FileUpload2').change(function () {
     ClearImportResponseValidation();
 });
    
    // Highlighting sidebar menu item
    var page = $('.breadcrumb').text();
    page = page.split('>');
    $('.sidebar-menu').children('.treeview').children('a').each(function () {
        var name = $(this).text();
        var classname = $(this).attr('class');
        if ($.trim(name) == $.trim(page[1])) {
                $(this).removeClass(classname);
                $(this).addClass(classname.split(' ')[0] + '-active normalline');
                $(this).children('span').css('color', '#2174bb');
                $(this).parent('li').addClass('treeview selected');
            }
    });
    //
    $(".searchText").bind("keydown", function (event) {
        var keycode = (event.keyCode ? event.keyCode : (event.which ? event.which : event.charCode));
        if (keycode == 13) {
            document.getElementById('btnSearch').click();
            return false;
        } else {
            return true;
        }
    });
    $(".btn-confirm-delete").focus();
    var currentURL = window.location.href;
    if (!currentURL.includes('Manager/Login/List.aspx')) {
        HideInProgressLoading();
    }
  $('[data-toggle="popover"]').popover(); //Enable popover text for "?" in all edit pages.

  fetchNotifications();
  setInterval(fetchNotifications, 300000);
});


function fetchNotifications() {
  $.ajax({
    url: '/api/UserManagement/Notifications',
    type: 'GET',
    contentType: 'application/json',
    success: function (response) {
      if (response && response.success) {
        updateNotificationUI(response.data)

      }
    },
    error: function (xhr, status, error) {
      console.error('Error fetching notifications:', error);
    }
  });
}

function updateNotificationUI(notifications) {
  const container = $('#notificationContainer');
  const countElement = $('#notificationCount');
  const totalElement = $('#totalNotificationCount');
  container.empty();
  const data = notifications.Table;
  const filteredData = data.filter(n => n.HideNotification != 1);
  const unreadCount = filteredData.filter(n => n.ViewedNotifications === null).length;
  if (filteredData.length == 0) {
    displayEmptyState(container);
    countElement.hide();
    return;
  }

  updateNotificationBadge(countElement, unreadCount);
  totalElement.text(filteredData.length + " Notifications" );
  container.html(renderNotifications(filteredData, unreadCount));
}

function displayEmptyState(container) {
  container.append(
    '<li class="notification-item empty"><div class="empty-state">No notifications found</div></li>'
  );
  $('#removeAllNotifications').hide();
  $('#totalNotificationCount').text("0 Notifications");
  $('.dropdown.notifications-menu.open').removeClass('open');
}

function updateNotificationBadge(countElement, unreadCount) {
  if (unreadCount > 0) {
    countElement.text(unreadCount).show();
  } else {
    countElement.hide();
  }
}

function parseNotificationDate(notification) {
  return notification.CREATED_ON;
}

function getNotificationTitle(notification) {
  return notification.HEADLINE;
}
function getNotificationArticalID(notification) {
  return notification.ARTICLE_ID;
}
function getNotificationBody(notification) {
  return notification.BODY;
}

function renderNotifications(list, unreadCount) {
  return list
    .map((notification, index) => {
      const notificationDate = parseNotificationDate(notification);
      const timeAgo = timeSince(notificationDate);
      const isUnread = index < unreadCount;
      return createNotificationItem(notification, timeAgo, isUnread);
    })
    .join('');
}

function createNotificationItem(notification, timeAgo, isUnread) {
  return `
   <li class="notification-item ${isUnread ? 'unread' : ''}">
   <span class="notification-content">
     <input type="hidden" class="article-id" id="ArticalID" value="${getNotificationArticalID(notification)}" />
     <span class="notification-header">
       <span class="notification-title">${getNotificationTitle(notification)}</span>
       <span class="notification-time">${timeAgo}</span>
         <span class="notification-close"
               onclick="removeSingleNotification(event,'${getNotificationArticalID(notification)}')">
           &times;
         </span>
     </span>
     <span class="notification-description">${getNotificationBody(notification)}</span>
   </span>
</li>

  `;
}
function convertTimezone
  (date, tzString) {
  return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", { timeZone: tzString }));
}

function timeSince(date) {
  var dbDate = new Date(date);
  if (isNaN(dbDate.getTime())) return "recently";
  const seconds = Math.floor((Date.now() - dbDate.getTime()) / 1000);
  if (seconds < 0) return "recently";
  let interval = seconds / 31536000;  // years
  if (interval > 1) return Math.floor(interval) + " years ago";
  interval = seconds / 2592000;  // months
  if (interval > 1) return Math.floor(interval) + " months ago";
  interval = seconds / 86400;  // days
  if (interval > 1) return Math.floor(interval) + " days ago";
  interval = seconds / 3600;  // hours
  if (interval >= 1) return Math.floor(interval) + " hours ago";
  interval = seconds / 60;  // minutes
  if (interval >= 1) return Math.floor(interval) + " minutes ago";
  return Math.floor(seconds) + " seconds ago";
}
$(document).on('click', '#notificationDropdown', function (e) {
  e.stopPropagation(); 
});

const SearchData = (url,oldText)=> {
    var newText = $(".searchText").val();
    url = RemoveParameterFromUrl(url, 'page');
    if (url.indexOf("search") != -1) {
        url = url.replace("search=" + encodeURIComponent(oldText), "search=" + encodeURIComponent(newText))
    }
    else {
        if(url.indexOf("?")!=-1)
            url = url + "&search=" + encodeURIComponent(newText)
        else
            url = url + "?search=" + encodeURIComponent(newText)
    }
    location.href = url;
}

function RemoveParameterFromUrl(url, parameter) {
  return url
    .replace(new RegExp('[?&]' + parameter + '=[^&#]*(#.*)?$'), '$1')
    .replace(new RegExp('([?&])' + parameter + '=[^&]*&'), '$1');
}

function ProbenchPage() {
    this.move = function move(url) {
        location.href = url;
    };

    this.GetParameterValues = function GetParameterValues(param) {
        var url = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&amp;');
        for (var i = 0; i < url.length; i++) {
            var urlparam = url[i].split('=');
            if (urlparam[0] == param) {
                return urlparam[1];
            }
        }
    };
}

function isJavaScriptWorking(){
    return true;
}


function PostConfiguration() {
    this.url;
    this.contentType = 'application/json; charset=utf-8';
    this.dataType = "json";
    this.type = "POST";
}

function DefaultPostConfiguration() {
    this.url;
    this.contentType = 'application/json; charset=utf-8';
    this.type = "POST";
}

function sendRequest(callbacks, configuration, currentdata) {
  ShowInProgressLoading();
    $.ajax({
        type: configuration.type,
        url: configuration.url,
        data: currentdata,
        processData: configuration.processData,
        contentType: configuration.contentType,
        dataType: configuration.dataType,
        success: callbacks.OnSuccess,
        failure: callbacks.OnFailure
    });
}

function sendRequestForLatestVersion(callbacks, configuration, currentdata, showloading) {
  if (showloading || typeof showloading === "undefined")
    ShowInProgressLoading();
    $.ajax({
        type: configuration.type,
        url: configuration.url,
        data: currentdata,
        processData: configuration.processData,
        contentType: configuration.contentType,
        dataType: configuration.dataType,
        success: callbacks.OnSuccess,
        error: callbacks.OnError
    });
}

function OnFailure(response) {
  if (response.status === 401)
    location.href = "../SignOut.aspx"
  else {
    var messageBox = new MessageBox();
    messageBox.Show("ERROR", response.d);
    HideInProgressLoading();
   }
}

function OnError(response) {
  if (response.status === 401)
    location.href = "../SignOut.aspx"
  else {
    var messageBox = new MessageBox();
    messageBox.Show("ERROR", "Error in connecting with server " + response.status + " " + response.statusText);
    HideInProgressLoading();
  }    
}

function UserMessages(){
    this.Messagetypes = {
        SUCCESS: { CssClass: "successmessage", Icon: "fa-check-circle" },
        ERROR: { CssClass: "errormessage", Icon: "fa-times-circle" },
        INFO: { CssClass: "infomessage", Icon: "fa-info-circle" },
        WARNING: { CssClass: "warningmessage", Icon: "fa-exclamation-triangle" }
    };

    this.getFormatedMessage = function getFormatedMessage(MessageType, Message) {
        return "<div class='"+ this.Messagetypes[MessageType].CssClass
            + " normalline' ><i class='fa " + this.Messagetypes[MessageType].Icon
            + " '></i>&nbsp;" + Message + "</div>";
    };
}

function MessageBox() {
    this.userMessages = new UserMessages();

    this.Show = function Show(MessageType, Message) {
        $(".MessageBox").empty();
        $(".MessageBox").append(this.userMessages.getFormatedMessage(MessageType, Message));
    };
}

function ShowInProgressLoading()
{
  $('#surveyNodesLoading').show();
}

function HideInProgressLoading() {
  $('#surveyNodesLoading').hide();
}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function GetReportFields(_brochurId) {
    var callbacks = {
        OnFailure: OnFailureReportFieldData,
    };
    $.ajax({
        type: 'POST',
        url: "Edit.aspx/GetReportFields",
        data: JSON.stringify({ brochurId: _brochurId }),
        contentType: 'application/json; charset=utf-8',
        success: function (response) {
          return response.d;            
        },
        failure: callbacks.OnFailure
    });
}
function OnFailureReportFieldData(response) {
}
$(document).ready(function () {
  $(".information").append("<i class='fa fa - warning'>");
});

function getUrlforAPI() {
    localStorage.setItem('fetchURL', window.location.origin);
}

function AddManagerHistoryLog(screen, itemId, data, action, note) {
    var obj = { Screen: screen, ItemId: itemId, Data: data, Action: action, Note: note };
    var callbacks = {
        OnSuccess: function (response) {
            HideInProgressLoading();
        },
        OnError: function (error) {
          OnError(error)
        }
    }
    var config = new PostConfiguration();
    config.url = localStorage.getItem("fetchURL") + "/api/Log/ManagerHistory";
    sendRequestForLatestVersion(callbacks, config, JSON.stringify(obj));
}

function copyTextToClipboard(text) {
  const cb = navigator.clipboard;
  return cb.writeText(text);
}

function InitializeModalPopup(modalId) {
    $('#' + modalId + '').modal('show');
    $(".close2").click(function () {
        $('#' + modalId + '').modal('hide');
    });
}
function ClearImportResponseValidation() {    
  if ($("#ctl00_Body_FileUpload2").val() != "" && $("#FromINSTANCE_ID").val() != "") {  
    $('.UserMessageParent').empty();
  }
}
/**
 * Restricts participant actions for non-admin users.
 * @param {string} userRole - The current user's role.
 * @param {string} tableSelector - jQuery selector for the main table (e.g., '#ParticipantFilterList').
 * @param {string} createBtnSelector - jQuery selector for the "create" button (e.g., 'a[title="Create new participant"]').
 * @param {string} emailListSelector - jQuery selector for the assigned users popup list (e.g., '#EmailList').
 */
function applyParticipantRoleRestrictions(userRole, tableSelector, createBtnSelector, emailListSelector) {
  if (userRole !== 'AdminOrSysDev') {
    // Remove all display name links by class, keeping only their text
    $(`${tableSelector} .participant-display-link`).each(function () {
      $(this).replaceWith($(this).text());
    });
    // Remove "Create new" button
    $(createBtnSelector).remove();
    // Remove "Edit" button in assigned users popup
    $(`${emailListSelector} .btn-edit`).remove();
    // Remove "Edit" button in action column
    $(`${tableSelector} .btn-edit`).remove();
  }
}

function createNotificationRecord() {
  var articleIds = getArticleIdsFromNotifications();

  if (articleIds.length == 0) {
    return;
  }
  $.ajax({
    type: 'POST',
    url: '/api/UserManagement/Notifications',
    data: JSON.stringify({ articleIds: articleIds}), 
    contentType: 'application/json', 
    success: function (response) { 
      fetchNotifications();
    },
    error: function (xhr, status, error) {
      console.error("Error fetching notifications:", error);
    }
  });
}


function removeNotifications(articleIds) {
  if (!articleIds || articleIds.length === 0) {
    return;
  }

  $.ajax({
    type: 'POST',
    url: '/api/UserManagement/RemoveNotifications',
    data: JSON.stringify({
      articleIds: articleIds
    }),
    contentType: 'application/json',
    success: function (response) {
      fetchNotifications();
    },
    error: function (xhr, status, error) {
      console.error("Error removing notifications:", error);
    }
  });
}

function removeAllNotifications() {
  const articleIds = getArticleIdsFromNotifications();
  removeNotifications(articleIds);
}
function removeSingleNotification(event, articleId) {
  if (event) {
    event.stopPropagation();
    event.preventDefault();
  }
  $(`li.notification-item input.article-id[value="${articleId}"]`)
    .closest('.notification-item')
    .remove();
  removeNotifications([articleId]);
}

function getArticleIdsFromNotifications() {
  const articleIds = [];
  $('li.notification-item').each(function () {
    const articleId = $(this).find('input.article-id').val();
    if (articleId) {
      articleIds.push(articleId);
    }
  });
  return articleIds;
}




